import React from 'react';
import styles from './SignIn.module.scss';
import BackgroundImage from "./components/background-image/BackgroundImage";
import clsx from "clsx";
import {BackIcon} from "../../../components/style-guide/icons";
import {Link} from "@reach/router";
import {AppRouters} from "../../../settings";
import {emptyFn} from "../../../shared";
import PropTypes from 'prop-types';
import SignInForm from "./components/form/SignInForm";
import SignInSuccessInfo from "./components/success-info/SignInSuccessInfo";

export const SignIn = (props) => {
  const {isSubmitting} = props;

  return (
    <div className={styles.container}>
      <div className={styles.backgroundImage}>
        <BackgroundImage/>
      </div>

      {!isSubmitting ? <SignInForm {...props}/> : <SignInSuccessInfo {...props}/>}

      <div className={"d-flex justify-content-center mt-4"}>
        <Link to={AppRouters.home} className={clsx("btn-clear p-3", styles.backButtonContainer)}>
          <BackIcon className="inline-icon" />
          <span>Regresar al inicio</span>
        </Link>
      </div>
    </div>
  );
};

SignIn.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  onResetSignIn: PropTypes.func,
  email: PropTypes.string,
}

SignIn.defaultProps = {
  onSubmit: emptyFn,
  isSubmitting: false,
  onResetSignIn: emptyFn,
  email: ""
}

export default React.memo(SignIn);
